
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy-direct-checkout/[addressId]",
      function () {
        return require("private-next-pages/buy-direct-checkout/[addressId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy-direct-checkout/[addressId]"])
      });
    }
  